




































import Vue from 'vue';

import { functions }    from '@/db/firestore.ts';

export default Vue.extend({
    props: {
        sub: {}
    },
    data() {
        return {
            armed: false,
            showSpin: false,
        }
    },
    methods: {
        armCancel(item) {
            this.armed = true;
        },
        cancelIt() {
            this.showSpin = true;
            
            // Call cancel subscription
            const cancelSub = functions.httpsCallable('cancelSub');

            cancelSub({ subid: this.sub.id })
            .then((val) => {
                console.log(val);
                if (val.data.success === false) { this.cancelError() } 
                else { this.cancelSuccess() }
            })
            .catch(e => { 
                console.error(e);
                this.cancelError(e);
            })
            .finally(() => {
                this.disarm();
                this.showSpin = false;
            })
        },
        cancelSuccess() {
            this.$toast.open({
                message: 'Subscription canceled',
                type: 'success',
                duration: 3000,
                position: 'top-right'
            });
        },
        cancelError(e) { this.toastAndError(this, 'There was an error. Plesae try again.', e); },
        disarm() {
            this.armed = false;
        }
    }
})
